import { Locale } from '@formatjs/intl-locale';
import { DEFAULT_LOCALE, DEFAULT_PRICE_COUNTRY, localesThatUseIPForPrices } from './constants';
import type { Session } from '@hooks/states/useSessionStore';

export const getPriceCountry = (locale?: string, session?: Session) => {
  if ((!locale && !session?.priceCountry) || localesThatUseIPForPrices.includes(locale)) {
    return DEFAULT_PRICE_COUNTRY;
  }

  const priceCountry = (session?.priceCountry ?? new Locale(locale).region)?.toUpperCase() || DEFAULT_PRICE_COUNTRY;

  return priceCountry === 'GB' ? 'UK' : priceCountry;
};

export const getRegionLanguage = (locale?: string) => {
  if (!locale) {
    return { language: DEFAULT_LOCALE, region: DEFAULT_PRICE_COUNTRY };
  }
  const regionLanguage = new Locale(locale);
  return {
    language: regionLanguage.language ?? DEFAULT_LOCALE,
    region: regionLanguage.region ?? DEFAULT_PRICE_COUNTRY,
  };
};
